<template>
    <section v-if="hasPermissions(['Associate Read','Associate Write', 'Associate Associate-Upload'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a list of active and inactive Associates. Click "Add Associate" to create a new Associate.
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="hasPermissions(['Associate Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
                <UploadOptions
                    :ref="'file_excel'"
                    :empty_format_data="empty_format_data"
                    :excel_file_headers="excel_file_headers"
                    :file_name="'associates_template_file'"
                    @data="upload($event)"
                    v-if="hasPermissions(['Associate Associate-Upload'])"
                />
                <a v-if="hasPermissions(['Associate Write'])" class="modal__buttons__item btn-width-3" href="/associates-mass-edit" v-html="'Mass Edit'"/>
                <button v-if="hasPermissions(['Associate Read'])" class="modal__buttons__item btn-width-3" v-html="'New Users'" @click="showNewUsersModal()"/>
                <a v-if="hasPermissions(['Associate-Permissions-Template Read'])" class="modal__buttons__item btn-width-3" v-html="'Templates'" :href="'/permissions-templates'"/>
                
                <a class="modal__buttons__item btn-width-5" v-if="hasPermissions(['Associate Read'])" :class="{'disabled button__disabled' : !selected}" @click="selected ? openAssociateQCHistoryReport() : null">Associate QC history</a>
                <a class="modal__buttons__item btn-width-3"  v-if="hasPermissions(['Associate Write'])" :class="{'disabled button__disabled' : !selected}" @click="selected ? massive_modal_delete() : null">
                    Mass Delete
                </a>
            </div>

            <div v-if="hasPermissions(['Associate Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <AssociatesAdvancedSearch
        class="mt-5"
        ref="advanced_search"
        :parent_associates="associates"
        :parent_pagination="pagination"
        :use_parent="true"
        :table_headers="table_headers"
        :checkeable="true"
        :historiable="false"
        :updateable="true"
        :rest_api="'associates'"
        :rest_api_pagination="rest_api_pagination"
        :parent_array_options_table="array_options_table"
        @emitLinkAction="emitLinkAction($event)"
        @passInitialData="getInitialData($event)"
        @modal_update="modal_update($event)"
        @paginateMoreRecordsParent="paginateMoreRecords($event)"
        @fetchMainListParent="fetchMainList($event)"
        :search="search"
        />

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <DeleteValidationsModal 
            :validate_data="delete_validations"
            :breadcrumb="breadcrumb"
            ref="DeleteValidationsModal"
            @replacingAssociates="replacingAssociates($event)"
        />

        <FormModal 
            :title="'New Associate'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            :associates_selected="associates_selected"
            @unshiftObject="unshift_object($event)"
            ref="form_modal"
        />
        <FormModalPermissions
            :rest_api="rest_api"
            :title="'User Permissions'"
            :permissions="permissions"
            :array_options="array_options"
            :breadcrumb="breadcrumb"
            ref="formModalPermissions"
        />

        <UpdateModal 
            :title="'Associate Update'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            :associates_selected="associates_selected"
            @spliceObject="splice_object($event)"
            ref="update_modal"
        />

        <SelectDateRange 
            :title="'Associate QC History'"
            :breadcrumb="breadcrumb"
            @getAssociateQCHistoryReport="getAssociateQCHistoryReport($event)"
        />

        <NewUsersModal 
        title="New Users"
        :breadcrumb="breadcrumb"
        :rest_api="rest_api"
        :notyf="notyf"
        ref="new_users_modal"
        />

        <WaitingModal/>

        <UploadSummary
            :breadcrumb="breadcrumb"
            :summary="summary"
            :excel_file_headers="excel_file_headers"
            :excel_data="excel_data"
            :file_name="'associates_types_falied_template_file'"
        />

        <HelperModal :helps="helps"/>


  </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import axios                    from    'axios';
import Breadcrumb               from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal             from    '@/components/WaitingModal'
import HelperModal              from    '@/components/HelperModal'
import FormResources            from    './form_resources'
import Resources                from    './resources'
import FormModal                from    './FormModal'
import SelectDateRange          from    './SelectDateRange'
import FormModalPermissions     from './FormModalPermissions'
import UpdateModal              from    './UpdateModal'
import DeletionMassiveModal     from    '@/components/DeletionMassiveModal'
import UploadOptions            from    '@/components/UploadOptions'
import UploadSummary            from    '@/components/UploadSummary'
import DeleteValidationsModal   from './DeleteValidationsModal';
import NewUsersModal            from './NewUsersModal';
import UnauthorizedComponent    from   '@/components/UnauthorizedComponent'
import AssociatesAdvancedSearch  from './AdvancedSearch/AssociatesAdvancedSearch'
import { Notyf }                from    'notyf';
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'; // for React and Vue
import _ from 'lodash'
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name:   'Associate',

    components:{
        Breadcrumb,
        WaitingModal,
        FormModal,
        FormModalPermissions,
        DeletionMassiveModal,
        UpdateModal,
        UploadOptions,
        UploadSummary,
        UnauthorizedComponent,
        DeleteValidationsModal,
        NewUsersModal,
        AssociatesAdvancedSearch,
        SelectDateRange,
        HelperModal
    },

    data(){
        return{
            notyf,
            axios,
            child_href:             '/associates-detail/',
            user:                   this.get_user(),
            title_page:             'Associates',
            rest_api:               'associates',
            rest_api_pagination:    `associates_pagination`,
            table_headers:          Resources.table_headers,
            breadcrumb:             Resources.breadcrumb,
            add_btn:                'Add Associate',
            shift_options:          FormResources.shift_options,
            single_select:          false,
            table_selection:        [],
            search:                 '',
            global_index:           null,
            single_object:          {},
            associates:             [],
            associates_selected:    [],
            array_options:          {},
            supervisors:            [],
            select_ids:             [],
            excel_file_headers:     Resources.excel_file_headers,
            empty_format_data:      Resources.empty_format_data,
            excel_fields_required:  Resources.excel_fields_required,
            summary:                [],
            excel_data:             [],
            permissions:            [],
            delete_validations:     [],
            array_options_table: [],
            pagination: null,
            helps:                  Resources.helps
        }
    },

    methods:{
        emitLinkAction(index)
        { 
            console.log(index)
            this.$refs.formModalPermissions.modalForUpdate(this.associates[index], index)
            window.$('#static-permissions').modal('show') 
        },
        
        unshift_object()
        {
            this.$refs.advanced_search.resetList()
        },
        
        set_supervisor(supervisor_object)
        {
            this.supervisor.unshift(supervisor_object)
        },

        splice_object()
        {
            this.$refs.advanced_search.resetList()
        },

        replacingAssociates()
        {
            this.$refs.advanced_search.resetList()
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.associates[index]
            window.$('#static-deletion').modal('show')
        },

        form_modal()
        {
            if(!this.user.has_facility){
                notyf.error('There is not exists a facility yet')
                return false
            }
            this.$refs.form_modal.refresh()
            window.$('#static').modal('show')
        },

        fill_data(data)
        {
            this.associates = data.associates

            this.permissions = data.permissions

            this.array_options = {
                cost_center_department_id:  data.departments,
                position_id:                data.positions,
                contract_type_id:           data.contract_types,
                shift:                      this.shift_options,
                role_id:                    data.roles,
                permissions_template_id:    data.permissions_templates,
                give_access_to:             data.facilities
            }
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.associates[index]
            this.shift_options.forEach((prop)=>{
                if(prop.name === this.single_object.shift)
                {
                    this.single_object.shift = prop.id
                }
            })
            // this.supervisor_request(this.single_object.id)
            this.$refs.update_modal.refresh()
            window.$('#static-update').modal('show')
        },

        showNewUsersModal()
        {
            this.$refs.new_users_modal.initialSetup();
            window.$('#static-new-users').modal('show')
        },

        async supervisor_request(id)
        {
            const request_object = {
                id: id !== undefined ? id : null,
                supervisor_request: true,
            }

            const response = await this.get(`${this.rest_api}/${JSON.stringify(request_object)}`)

            if(response.status)
            {
                this.supervisors = response.data.supervisors
            }
            else
            {
                this.error_handling(response)
            }
        },

        trashing(index)
        {
            this.associates.splice(index, 1)
        },

        massive_modal_delete()
        {
            let selection = this.$refs.advanced_search.returnedAssociatesToParent()

            selection.checked_items = selection.checked_items.map(item => item.id)
            selection.unchecked_items = selection.unchecked_items.map(item => item.id)

            this.select_ids = selection

            if(this.select_ids.checked_items.length )
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let response = await this.massive_delete(this.select_ids, null, true)

            if(response)
            {
                if(response.data)
                {
                    this.delete_validations = response.data.validations

                    this.$refs.advanced_search.resetList()

                    if(this.delete_validations.length)
                    {
                        this.$refs.DeleteValidationsModal.see_history = false
                        window.$('#delete-validations').modal('show')
                    }
                }

                response.data.associates_deleted_id.forEach( item =>
                {
                    const index = this.associates.findIndex(value => value.decrypt_id == item)
                    if(index > -1)
                    {
                        this.associates.splice(index, 1)
                    }
                })
                this.select_ids = []
            }
        },

        async upload(data)
        {
            const send_data = [];
            this.excel_data = []

            for ( const value of data ) {
                const entity = {}

                for (const prop in this.excel_file_headers) {
                    entity[this.excel_file_headers[prop]] = this.parse_boolean(value[prop])
                }

                this.excel_data.push({... entity})

                const role = this.array_options.role_id.find(item => item.name == entity.role_id)
                entity.is_supervisor = entity.role_id === 'Supervisor' ? true : false
                entity.role_id = role ? role.id : undefined

                const permissions_template_id = this.array_options.permissions_template_id.find(item => item.name == entity.permissions_template_id)
                entity.permissions_template_id = permissions_template_id ? permissions_template_id.id : undefined

                const shift = this.array_options.shift.find(item => item.name == entity.shift)
                entity.shift = shift ? shift.id : entity.shift ? 'x' : undefined

                const position = this.array_options.position_id.find(item => item.name == entity.position_id)
                entity.position_id = position ? position.id : undefined

                const contract_type = this.array_options.contract_type_id.find(item => item.name == entity.contract_type_id)
                entity.contract_type_id = contract_type ? contract_type.id : undefined

                const cost_center_department_id = this.array_options.cost_center_department_id.find(item => item.name == entity.cost_center_department_id)
                entity.cost_center_department_id = cost_center_department_id ? cost_center_department_id.id : undefined

                send_data.push(entity)
            }

           
            this.loader(true)
            const response = await this.post(`${this.rest_api}/massive`, { associates: send_data })
            this.loader()

            if(response.status)
            {
                notyf.success('Success!')
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')
                
               this.$refs.advanced_search.resetList()
            }
            else
            {
                this.error_handling(response)
            }
            
            this.$refs.file_excel.clear_data()
        },

        async paginateMoreRecords(params)
        {
            if(this.associates.length >= this.pagination?.total)
            {
                return;
            }
            this.$refs.advanced_search.showLoader()

            await this.apiRequest(params)
        },

        async fetchMainList(params) 
        {
            this.associates = [];
            this.$refs.advanced_search.showLoader()
            await this.apiRequest(params, true)
        },


        async loadMoreRecords(data, reset_list)
        {
            if(reset_list)
            {
                this.associates = []
            }
            if(data.pagination.data.length)
            {
                data.pagination.data.forEach((item) => {
                    item.checked = this.$refs.advanced_search.isSelectAll()
                    this.associates.push(item)
                })
            }

            this.pagination = data.pagination

            this.$refs.advanced_search.hideLoader(data.pagination.data)
        },

        getInitialData(data)
        {
            this.permissions = data.permissions

            this.array_options = {
                cost_center_department_id:  data.departments,
                position_id:                data.positions,
                territory_id:               data.countries,
                contract_type_id:           data.contact_types,
                shift:                      this.shift_options,
                role_id:                    data.roles,
                permissions_template_id:    data.permissions_templates,
                give_access_to:             data.facilities
            }
        },

        openAssociateQCHistoryReport()
        {
            window.$('#static-select-date-range').modal('show')
        },

        getAssociateQCHistoryReport(params)
        {
            let selection = this.$refs.advanced_search.returnedAssociatesToParent()

            selection.unchecked_items = selection.unchecked_items.map(item => item.id)
            selection.checked_items = selection.checked_items.map(item => item.id)

            if(selection.select_all)
            {
                selection.checked_items = []
            }

            selection['date_range'] = params.date_range

            let url = `/standard-reports/buildings/associate-qc-history`

            url += `?form_data=${JSON.stringify(selection)}`

            window.open(url, '_blank');
        },

        debounceInput:  _.debounce(function (e)  {
            this.search = e
        },800),

    },

    mounted()
    {
        if(!this.hasPermissions(['Associate Permissions-Read']))
        {
            this.table_headers.pop()
        }
    },

    computed:
    {
         selected()
        {
            const bool = this.associates.filter(item => item.checked)
            return Boolean(bool.length)
        }
    }
}
</script>